import { defineComponent as _defineComponent } from 'vue'
import type { Nav } from '@/util/anchorNavData'
import { translate } from '@/util/commonFun'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    navs: null,
    prefix: { default: 'engraving' },
    getContainer: null
  },
  setup(__props: any) {



function handlePrevent(e: Event) {
  e.preventDefault()
}

return { __sfc: true,handlePrevent, translate }
}

})